import { styled } from "@mui/system";

export const ModalOverlay = styled("div")(() => ({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 999,
}));

export const ModalContainer = styled("div")(() => ({
  width: "90%",
  maxWidth: 700,
  backgroundColor: "#ffffff",
  borderRadius: 16,
  padding: 24,
  boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
}));

export const ModalHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 16,
}));

export const ModalTitle = styled("h3")(() => ({
  fontSize: 18,
  fontWeight: 600,
}));

export const CloseButton = styled("button")(() => ({
  border: "none",
  background: "transparent",
  fontSize: 20,
  cursor: "pointer",
}));

export const FormGroup = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 6,
  marginBottom: 16,
}));

export const Label = styled("label")(() => ({
  fontSize: 13,
  fontWeight: 500,
  color: "#374151",
}));

export const Input = styled("input")(() => ({
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
  outline: "none",
}));

export const TextArea = styled("textarea")(() => ({
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
  minHeight: 120,
  resize: "vertical",
  outline: "none",
}));

export const ModalFooter = styled("div")(() => ({
  display: "flex",
  position: "sticky",
  top: 0,
  zIndex: 99,
  justifyContent: "flex-start",
  gap: 12,
  marginTop: 24,
  backgroundColor: "#f9fafb",
}));

export const Button = styled("button")(() => ({
  padding: "10px 16px",
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
  border: "none",
  backgroundColor: "#2563eb",
  color: "#ffffff",
  "&.cancel": {
    backgroundColor: "#e5e7eb",
    color: "#111827",
  },
}));

export const StatusSelect = styled("select")(() => ({
  width: "100%",
  padding: "10px 40px 10px 12px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  fontSize: 14,
  backgroundColor: "#ffffff",
  color: "#111827",
  cursor: "pointer",

  appearance: "none",
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg fill='none' stroke='%236b7280' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 12px center",
  backgroundSize: 16,

  "&:focus": {
    outline: "none",
    borderColor: "#2563eb",
    boxShadow: "0 0 0 2px rgba(37, 99, 235, 0.15)",
  },
}));

export const UploadInput = styled("input")(() => ({
  display: "none",
}));

export const UploadBox = styled("label")(() => ({
  width: "100%",
  height: 140,
  borderRadius: 8,
  border: "1px dashed #e5e7eb",
  backgroundColor: "#ffffff",
  color: "#6b7280",
  cursor: "pointer",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,

  fontSize: 14,

  position: "relative", // thêm

  overflow: "hidden", // thêm

  transition: "all 0.2s ease",

  "&:hover": {
    borderColor: "#2563eb",
    backgroundColor: "#f9fafb",
  },

  "&:focus-within": {
    borderColor: "#2563eb",
    boxShadow: "0 0 0 2px rgba(37, 99, 235, 0.15)",
  },
}));

export const UploadPreview = styled("img")(() => ({
  maxHeight: 120,
  maxWidth: "100%",
  borderRadius: 6,
  objectFit: "cover",
}));
